'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isState;

var _getEntry2 = require('./_get-entry');

var _getEntry3 = _interopRequireDefault(_getEntry2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isState(resource, state) {
    if (resource === state) return true;

    var entry = (0, _getEntry3.default)(resource);

    if (!entry) return false;

    var compare = typeof state === 'function' ? state : function (e) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return r || e && e.state === state;
    };

    if (Array.isArray(entry)) return entry.reduce(function (r, e) {
        return compare(e, r);
    }, void 0);

    return compare(entry);
}